/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {

    enum FilterBy {
        All,
        WithExceptions
    }

    interface IDateRangeAttributes {
        maxDate: Date;
    }


    interface IRecordsCriteria {
        from: Date;
        to: Date;
        employeeEntityTypeEnum: Model.EmployeeEntityTypeEnum;
    }

    interface IRecordsCriteriaModel extends IRecordsCriteria {
        getForFileName(): string;
    }

    class RecordsCriteriaModel implements IRecordsCriteriaModel {
        from: Date;
        to: Date;
        employeeEntityTypeEnum: Model.EmployeeEntityTypeEnum;

        constructor(props: IRecordsCriteria) {
            Object.assign(this, props);
        }

        getCriteria() {
            return {
                startDate: moment(this.from).startOf('day').toDate(),
                endDate: moment(this.to).add(1, 'day').startOf('day').toDate(),
                employeeEntityTypeEnum: this.employeeEntityTypeEnum
            };
        }

        public getForFileName(): string {
            return `${moment(this.from).format('MMDDYYYY')}-${moment(this.to).format('MMDDYYYY')}`;
        }
    }

    export class TimeClockSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        criteriaModel: RecordsCriteriaModel;
        dateRangeAttributes: IDateRangeAttributes;

        allRecordsForReview: ITimeClockExportModel[];
        recordsForReview: ITimeClockExportModel[];
        fameAdvantageApi: Meevo.Plugins.FameAdvantage.IFameAdvantageApi;
        availableFilters: { value: number; label: string; }[];
        filterBy: FilterBy;
        exportFileName: string;
        showExportEnabledError: boolean;
        noData: boolean;

        get exportEnabled() {
            return this.allRecordsForReview.length > 0
                && this.allRecordsForReview.filter((row) => !!row.timeOut).length === this.allRecordsForReview.length
                ;
        }

        get recordsWithExceptions(): ITimeClockExportModel[] {
            return this.allRecordsForReview.filter((row) => !row.timeOut);
        }

        constructor(sectionId: number,
                    displayNameContentKey: string,
                    template: string,
                    isPrimarySection: boolean,
                    handlesOwnCrud: boolean,
                    baseEndpoint: string,
                    sectionEndpoint: string,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    fameAdvantageApi: Meevo.Plugins.FameAdvantage.IFameAdvantageApi,
                    noun: Meevo.Model.NounEnum = null,
                    identityService: Components.Common.IIdentityService = null,
                    sectionSecurityKey: string,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected dataExportService: Meevo.Components.Common.IDataExportService,
                    protected $translate: ng.translate.ITranslateService,
                    protected $filter: ng.IFilterService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    private $rootScope: angular.IRootScopeService,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    private $state: ng.ui.IStateService,
                    protected $scope: ng.IScope) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, fameAdvantageApi, noun, identityService, sectionSecurityKey);

            this.fameAdvantageApi = fameAdvantageApi;
            this.allRecordsForReview = [];
            this.recordsForReview = [];
            this.availableFilters = [
                {value: FilterBy.All, label: 'LABEL_ALL_RECORDS'},
                {value: FilterBy.WithExceptions, label: 'LABEL_RECORDS_WITH_EXCEPTIONS'},
            ];
            this.filterBy = FilterBy.All;
            this.showExportEnabledError = false;
            this.noData = false;

            this.criteriaModel = new RecordsCriteriaModel({
                from: new Date(),
                to: new Date(),
                employeeEntityTypeEnum: Model.EmployeeEntityTypeEnum.Student
            });
            this.dateRangeAttributes = {
                maxDate: new Date()
            };

            const stateName: string = $state.current.name;

            $scope.$on('$stateChangeSuccess',
                (event, toState) => {
                    if (toState.name === stateName) {
                        this.loadRecordsForReview();
                    }
                });
        }

        selected(): void {
            super.selected();
            this.showExportEnabledError = false;
        }

        loadRecordsForReview() {
            this.busyService.start();
            this.showExportEnabledError = false;
            this.noData = false;
            this.fameAdvantageApi
                .loadTimeClockRecordsForReview(this.criteriaModel.getCriteria())
                .then((res) => {
                    this.allRecordsForReview = res;
                    this.noData = this.allRecordsForReview.length === 0;

                    if (this.recordsWithExceptions.length > 0) {
                        this.filterBy = FilterBy.WithExceptions;
                    }

                    this.busyService.stop();
                })
                .finally(() => {
                    this.onFilterChanged();
                    this.exportFileName = this.generateFileName();
                    this.busyService.stop();
                });
        }

        export() {
            if (!this.exportEnabled) {
                this.showExportEnabledError = true;

                return;
            }
            const txtFile = this.allRecordsForReview.map((record) => record.formatForFile()).join('\n');

            this.dataExportService.generateFile(txtFile, this.exportFileName, Meevo.Components.Common.FileTypeEnum.TXT);

            this.showExportEnabledError = false;
        }

        setMissingField(row: ITimeClockExportModel) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.schedulesManager,
                stateParams: {
                    data: row
                },
            });
        }

        onFilterChanged() {
            this.recordsForReview = this.filterBy === FilterBy.WithExceptions
                ? this.recordsWithExceptions
                : this.allRecordsForReview;
        }

        private generateFileName(): string {
            return `${this.identityService.current().locationName}_${this.criteriaModel.getForFileName()}`;
        }
    }
}
